import  { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { BasicTooltip } from 'thrive-components';

const FormDetailsPortal = () => {
    let formId;
    let formUrl;
    let listType;
    let contentId;

    const [targetContainer, setTargetContainer] = useState<HTMLDivElement>();

    useEffect(() => {
        setTargetContainer(document.getElementById('react-form-response-portal') as HTMLDivElement);
    },[])
    
    if (!targetContainer) {
        //if there is nowhere for the portal, do not display
        return null;
    } else {
            formId = Number(targetContainer.getAttribute('data-form-id'));
            formUrl = String(targetContainer.getAttribute('data-csv-url'));
            listType = String(targetContainer.getAttribute('data-list-type'));
            contentId = Number(targetContainer.getAttribute('data-content-id'));
            
              

        return ReactDOM.createPortal(
            <FormDetailsContainer fId={formId} formUrl={formUrl} listType={listType} cId={contentId}/>,
            targetContainer
        );
    }
}

export default FormDetailsPortal

export const FormDetailsContainer = ({fId, listType, cId}: {fId?: number, formUrl?: string, listType?:string, cId?: number}) => {

    const [showFormResponseArea, setShowFormResponseArea] = useState<boolean>(listType === 'Form');
    const [formId, setFormId] = useState<number>(Number(fId))
    const [contentId, setContentId] = useState<number>(Number(cId))


    function setFormUrlAndFormId(contentId: number, formId:number) {
        setFormId(formId);
        setContentId(contentId);
    }

    useObserveForm(setShowFormResponseArea)

    useEffect(() => {
        ;(window as any).functions = {...window.functions, setFormIdReact: setFormUrlAndFormId}
    },[])


    if(!showFormResponseArea) {
        return <></>
    }

    return (
        <div className="panel">
            <div className="download-form-response-panel">
                <h2 className="title">Form Entries</h2>
                <span className="response-form-description">Download all responses collected for this form.</span>
                {formId 
                    ? <a 
                        className={`response-form-download-button`}
                        href={`/api/content/list/${contentId}/form/${formId}/report`}
                        target='__blank'
                    >
                        Download CSV
                    </a>
                    : 
                    <BasicTooltip
                        className={`activity-item-timestamp-tooltip below`} text={"Please publish the form to enable CSV download"}
                    >
                        <span className={`response-form-download-button disabled`}>Download CSV</span>
                    </BasicTooltip>
                   
                }
            </div>
        </div>
    )
}

const useObserveForm = (setShowFormResponseArea: (val: boolean) => void) => {
    useEffect(() => {
        ;(document?.querySelector('#formlistradio') as HTMLInputElement).addEventListener('change', () => {
            setShowFormResponseArea(true);
        });

        ['#defaultlistradio', '#userlistradio', '#recognitionlistradio'].forEach(selector => {
            const radio = document?.querySelector(selector);

            if(radio) {
                ;(document?.querySelector(selector) as HTMLInputElement).addEventListener('change', () => {
                    setShowFormResponseArea(false);
                })
            }

        })
    }, [])
}